import baseURL from "../common/axios";
class Commonservices {
  GetRoles(EmailId, Password) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "Login/GetRoles?EmailId=" + EmailId + "&Password=" + Password + ""
    );
  }
  Login(UserId) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "Login/GetLoginVerification?UserId=" + UserId + ""
    );
  }
  HMSLoginVerification(UserId) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "Login/GetHMSLoginVerification?UserId=" + UserId + ""
    );
  }
  GetRolesByUserId(UserId, BranchId) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "RoleMaster/GetRolesByUserId?UserId=" +
        UserId +
        "&BranchId=" +
        BranchId +
        ""
    );
  }
  GetBranchesByUserId(UserId) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "BranchMaster/GetBranchesByUserId?UserId=" + UserId + ""
    );
  }
  LogOut(Key) {
    debugger;
    return baseURL.httpbaseURL.post("Common/LogoutSession?key=" + Key + "");
  }
  Session(objlogin) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.post("Common/Session", objlogin);
  }
}
export default new Commonservices();
